import React from "react";
import { Statistic } from "antd";
import dayjs from "dayjs";

interface Stats {
  inwardPending: number;
  outwardPending: number;
  clearedThisMonth: number;
  bouncedTotal: number;
}

interface ChequeStatsBarProps {
  stats: Stats;
  monthLabel: string;
}

const fmt = (n: number) =>
  n.toLocaleString(undefined, { minimumFractionDigits: 2 });

export const ChequeStatsBar: React.FC<ChequeStatsBarProps> = ({
  stats,
  monthLabel,
}) => {
  const items = [
    {
      label: "Inward Pending",
      value: stats.inwardPending,
    },
    {
      label: "Outward Pending",
      value: stats.outwardPending,
    },
    {
      label: `Cleared (${monthLabel})`,
      value: stats.clearedThisMonth,
    },
    {
      label: "Bounced (All Time)",
      value: stats.bouncedTotal,
    },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-gray-200 border border-gray-200 rounded overflow-hidden">
      {items.map((item) => (
        <div key={item.label} className="bg-white px-4 py-3">
          <div className="text-xs text-gray-500 mb-1">{item.label}</div>
          <div className="text-sm font-semibold text-gray-900">
            LKR {fmt(item.value)}
          </div>
        </div>
      ))}
    </div>
  );
};
